'use strict';

bbw.directive.bbwPhotoSrc = ['bbw.RetinaDetectorSvc', function(retinaDetector) {
    return {
        restrict: 'A',
        scope: {
            photoUrl: '=bbwPhotoSrc',
            max: '=max'
        },
        link: function(scope, element) {
            var getSrc = function(photoUrl) {
                var href;
                if (retinaDetector.isRetina() && photoUrl.href_x2) {
                    href = photoUrl.href_x2;
                } else {
                    href = photoUrl.href;
                }
                if (!href) {
                    return undefined;
                }
                return ngtk.tools.string.format(
                    'url({0})',
                    JSON.stringify(href)
                );
            };
            var updatePhoto = function(photoUrl) {
                if (!photoUrl || (photoUrl.hash && photoUrl.hash === element.attr('data-pshash'))) {
                    return;
                }
                element.attr('data-pshash', photoUrl.hash);
                var css = {
                    backgroundRepeat: 'no-repeat'
                };
                if (scope.max) {
                    css.maxWidth = photoUrl.size.container_width + 'px';
                    css.maxHeight = photoUrl.size.container_height + 'px';
                } else {
                    css.width = photoUrl.size.container_width + 'px';
                    css.height = photoUrl.size.container_height + 'px';
                }
                element[0].className = element[0].className.replace(/\bsicon[^\s]*/g, '').replace(/\bphoto-stub\b/g, '').trim();
                if (photoUrl.stub) {
                    if (photoUrl.stub == 'stub') {
                        element.addClass([
                            'photo-stub',
                            'sicon',
                            'sicon-stub-stub'
                        ].join(' '));
                    } else {
                        element.addClass([
                            'photo-stub',
                            'sicon',
                            'sicon-stub-' + photoUrl.size_name,
                            'sicon-stub-' + photoUrl.size_name + '-' + photoUrl.stub
                        ].join(' '));
                    }
                    css.backgroundPosition = null;
                    css.backgroundSize = null;
                    css.backgroundImage = null;
                } else {
                    angular.extend(css, {
                        backgroundPosition: 'center center',
                        backgroundSize: ngtk.tools.string.format('{0}px {1}px', photoUrl.size.width, photoUrl.size.height),
                        backgroundImage: getSrc(photoUrl)
                    });
                }
                if (photoUrl.icon) {
                    element.addClass([
                        'sicon-icon',
                        'sicon-icon-' + photoUrl.size_name,
                        'sicon-icon-' + photoUrl.icon
                    ].join(' '));
                }
                element.css(css);
            };
            scope.$watch('photoUrl', updatePhoto);
        }
    };
}];
